import React from 'react';
import { CheckCircle, X } from 'lucide-react';
import { useTranslation } from 'react-i18next';

interface SuccessBannerProps {
  message: string | null;
  onDismiss: () => void;
  className?: string;
}

export const SuccessBanner: React.FC<SuccessBannerProps> = ({
  message,
  onDismiss,
  className = '',
}) => {
  const { t } = useTranslation();

  if (!message) return null;

  return (
    <div
      className={`mb-6 p-4 bg-green-50 border border-green-200 rounded-lg flex items-center space-x-2 ${className}`}
    >
      <CheckCircle className="w-5 h-5 text-green-500" />
      <span className="text-green-700">{message}</span>
      <button
        onClick={onDismiss}
        className="ml-auto text-green-500 hover:text-green-700"
        aria-label={t('tools.successBanner.dismiss')}
      >
        <X className="w-4 h-4" />
      </button>
    </div>
  );
};
